export function utf8tob64(str: string) {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode(parseInt(p1, 16));
    })
  );
}

export function b64toutf8(str: string) {
    try {
        // Old solution, written by Gino
        return decodeURIComponent(
            Array.prototype.map
                .call(atob(str), c => {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );
    } catch (e) {
        // Alternative, used to support special char like "é" if the uri is not encoded.
        // TODO: Maybe consider to properly remove or move the old solution, to have something clean and generic.
        const utf8String = atob(str);
        let decodedString = "";

        for (let i = 0; i < utf8String.length; i++) {
            const char = utf8String.charCodeAt(i);
            decodedString += String.fromCharCode(char);
        }

        return decodedString;
    }
}
